import { render } from "./EmailModalChange.vue?vue&type=template&id=16805131&scoped=true"
import script from "./EmailModalChange.vue?vue&type=script&lang=js"
export * from "./EmailModalChange.vue?vue&type=script&lang=js"

import "./EmailModalChange.vue?vue&type=style&index=0&id=16805131&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-16805131"

export default script